export default {
    'arrow-left': '\ue749',
    'arrow-up': '\ue74c',
    'arrow-down': '\ue8a4',
    'arrow-right': '\ue748',
    'Rightarrow': '\ue7c5',
    'leftarrow': '\ue793',
    'rising': '\ue703',
    'falling': '\ue780',
    'double-arrow-left': '\ue775',
    'double-arro-right': '\ue773',
    'map1': '\ue849',
    'apparel': '\ue74a',
    'paylater-fill': '\ue84a',
    'all1': '\ue74b',
    'phone-fill': '\ue84b',
    'online-tracking-fill': '\ue84c',
    'ascending': '\ue74d',
    'play-fill1': '\ue84d',
    'ashbin': '\ue74e',
    'pdf-fill': '\ue84e',
    'atm': '\ue74f',
    'phone1': '\ue84f',
    'bad': '\ue750',
    'pin-fill': '\ue850',
    'attachent': '\ue751',
    'product-fill': '\ue851',
    'browse': '\ue752',
    'rankinglist-fill': '\ue852',
    'beauty': '\ue753',
    'reduce-fill': '\ue853',
    'atm-away': '\ue754',
    'reeor-fill': '\ue854',
    'assessed-badge': '\ue755',
    'pic-fill1': '\ue855',
    'auto1': '\ue756',
    'rankinglist': '\ue856',
    'bags': '\ue757',
    'product1': '\ue857',
    'calendar': '\ue758',
    'prompt-fill1': '\ue858',
    'cart-full': '\ue759',
    'resonserate-fill': '\ue859',
    'calculator': '\ue75a',
    'remind-fill': '\ue85a',
    'cameraswitching': '\ue75b',
    'Rightbutton-fill': '\ue85b',
    'cecurity-protection': '\ue75c',
    'RFQ-logo-fill': '\ue85c',
    'category': '\ue75d',
    'RFQ-word-fill': '\ue85d',
    'close': '\ue75e',
    'searchcart-fill': '\ue85e',
    'certified-supplier': '\ue75f',
    'salescenter-fill': '\ue85f',
    'cart-Empty': '\ue760',
    'save-fill': '\ue860',
    'code1': '\ue761',
    'security-fill': '\ue861',
    'color': '\ue762',
    'Similarproducts-fill': '\ue862',
    'conditions': '\ue763',
    'signboard-fill': '\ue863',
    'confirm': '\ue764',
    'service-fill': '\ue864',
    'company': '\ue765',
    'shuffling-banner-fill': '\ue865',
    'ali-clould': '\ue766',
    'supplier-features-fill': '\ue866',
    'copy1': '\ue767',
    'store-fill': '\ue867',
    'credit-level': '\ue768',
    'smile-fill': '\ue868',
    'coupons': '\ue769',
    'success-fill': '\ue869',
    'connections': '\ue76a',
    'sound-filling-fill': '\ue86a',
    'cry': '\ue76b',
    'sound-Mute1': '\ue86b',
    'costoms-alearance': '\ue76c',
    'suspended-fill': '\ue86c',
    'clock': '\ue76d',
    'tool-fill': '\ue86d',
    'CurrencyConverter': '\ue76e',
    'task-management-fill': '\ue86e',
    'cut': '\ue76f',
    'unlock-fill': '\ue86f',
    'data1': '\ue770',
    'trust-fill': '\ue870',
    'Customermanagement': '\ue771',
    'vip-fill': '\ue871',
    'descending': '\ue772',
    'set1': '\ue872',
    'Top-fill': '\ue873',
    'customization': '\ue774',
    'viewlarger1': '\ue874',
    'voice-fill': '\ue875',
    'discount': '\ue776',
    'warning-fill': '\ue876',
    'download': '\ue777',
    'warehouse-fill': '\ue877',
    'dollar1': '\ue778',
    'zip-fill': '\ue878',
    'default-template': '\ue779',
    'trade-assurance-fill': '\ue879',
    'editor1': '\ue77a',
    'vs-fill': '\ue87a',
    'eletrical': '\ue77b',
    'video1': '\ue87b',
    'electronics': '\ue77c',
    'template-fill': '\ue87c',
    'etrical-equipm': '\ue77d',
    'wallet1': '\ue87d',
    'ellipsis': '\ue77e',
    'training1': '\ue87e',
    'email': '\ue77f',
    'packing-labeling-fill': '\ue87f',
    'Exportservices-fill': '\ue880',
    'earth': '\ue781',
    'brand-fill': '\ue881',
    'filter': '\ue782',
    'collection': '\ue882',
    'furniture': '\ue783',
    'consumption-fill': '\ue883',
    'folder': '\ue784',
    'collection-fill': '\ue884',
    'feeds': '\ue785',
    'brand': '\ue885',
    'history1': '\ue786',
    'rejected-order-fill': '\ue886',
    'hardware': '\ue787',
    'homepage-ads-fill': '\ue887',
    'help': '\ue788',
    'homepage-ads': '\ue888',
    'good': '\ue789',
    'scenes-fill': '\ue889',
    'Householdappliances': '\ue78a',
    'scenes': '\ue88a',
    'gift1': '\ue78b',
    'similar-product-fill': '\ue88b',
    'form': '\ue78c',
    'topraning-fill': '\ue88c',
    'image-text': '\ue78d',
    'consumption': '\ue88d',
    'hot': '\ue78e',
    'topraning': '\ue88e',
    'inspection': '\ue78f',
    'gold-supplier': '\ue88f',
    'leftbutton': '\ue790',
    'messagecenter-fill': '\ue890',
    'jewelry': '\ue791',
    'quick': '\ue891',
    'ipad': '\ue792',
    'writing': '\ue892',
    'docjpge-fill': '\ue893',
    'integral1': '\ue794',
    'jpge-fill': '\ue894',
    'kitchen': '\ue795',
    'gifjpge-fill': '\ue895',
    'inquiry-template': '\ue796',
    'bmpjpge-fill': '\ue896',
    'link': '\ue797',
    'tifjpge-fill': '\ue897',
    'libra': '\ue798',
    'pngjpge-fill': '\ue898',
    'loading': '\ue799',
    'Hometextile': '\ue899',
    'listing-content': '\ue79a',
    'home': '\ue89a',
    'lights': '\ue79b',
    'sendinquiry-fill': '\ue89b',
    'logistics-icon': '\ue79c',
    'comments-fill': '\ue89c',
    'messagecenter': '\ue79d',
    'account-fill': '\ue89d',
    'mobile-phone': '\ue79e',
    'feed-logo-fill': '\ue89e',
    'manage-order': '\ue79f',
    'feed-logo': '\ue89f',
    'move': '\ue7a0',
    'home-fill': '\ue8a0',
    'Moneymanagement': '\ue7a1',
    'add-select': '\ue8a1',
    'namecard': '\ue7a2',
    'sami-select': '\ue8a2',
    'map': '\ue7a3',
    'camera': '\ue8a3',
    'Newuserzone': '\ue7a4',
    'multi-language': '\ue7a5',
    'account': '\ue8a5',
    'office': '\ue7a6',
    'comments': '\ue8a6',
    'notice': '\ue7a7',
    'cart-Empty1': '\ue8a7',
    'ontimeshipment': '\ue7a8',
    'favorites': '\ue8a8',
    'office-supplies': '\ue7a9',
    'order': '\ue8a9',
    'password': '\ue7aa',
    'search': '\ue8aa',
    'Notvisible1': '\ue7ab',
    'trade-assurance': '\ue8ab',
    'operation': '\ue7ac',
    'usercenter1': '\ue8ac',
    'packaging': '\ue7ad',
    'tradingdata': '\ue8ad',
    'online-tracking': '\ue7ae',
    'microphone': '\ue8ae',
    'packing-labeling': '\ue7af',
    'txt': '\ue8af',
    'phone': '\ue7b0',
    'xlsx': '\ue8b0',
    'pic1': '\ue7b1',
    'banzhengfuwu': '\ue8b1',
    'pin': '\ue7b2',
    'cangku': '\ue8b2',
    'play1': '\ue7b3',
    'daibancaishui': '\ue8b3',
    'logistic-logo': '\ue7b4',
    'jizhuangxiang': '\ue8b4',
    'print': '\ue7b5',
    'jiaobiao': '\ue8b5',
    'product': '\ue7b6',
    'kehupandian': '\ue8b6',
    'machinery': '\ue7b7',
    'dongtai': '\ue8b7',
    'process': '\ue7b8',
    'daikuan': '\ue8b8',
    'prompt': '\ue7b9',
    'shengyijing': '\ue8b9',
    'QRcode1': '\ue7ba',
    'jiehui': '\ue8ba',
    'reeor': '\ue7bb',
    'fencengpeizhi': '\ue8bb',
    'reduce': '\ue7bc',
    'shenqingjilu': '\ue8bc',
    'Non-staplefood': '\ue7bd',
    'shangchuanbeiandanzheng': '\ue8bd',
    'rejected-order': '\ue7be',
    'shangchuan': '\ue8be',
    'resonserate': '\ue7bf',
    'kehuquanyi': '\ue8bf',
    'remind': '\ue7c0',
    'suoxiao': '\ue8c0',
    'responsetime': '\ue7c1',
    'quanyipeizhi': '\ue8c1',
    'return': '\ue7c2',
    'shuangshen': '\ue8c2',
    'paylater': '\ue7c3',
    'tongguan': '\ue8c3',
    'rising1': '\ue7c4',
    'tuishui': '\ue8c4',
    'tongguanshuju': '\ue8c5',
    'rmb1': '\ue7c6',
    'kuaidiwuliu': '\ue8c6',
    'RFQ-logo': '\ue7c7',
    'wuliuchanpin': '\ue8c7',
    'save': '\ue7c8',
    'waihuishuju': '\ue8c8',
    'scanning': '\ue7c9',
    'xinxibar_shouji': '\ue8c9',
    'security': '\ue7ca',
    'xinwaizongyewu': '\ue8ca',
    'salescenter': '\ue7cb',
    'wuliudingdan': '\ue8cb',
    'seleted': '\ue7cc',
    'zhongjianren': '\ue8cc',
    'searchcart': '\ue7cd',
    'xinxibar_zhanghu': '\ue8cd',
    'raw': '\ue7ce',
    'yidatong': '\ue8ce',
    'service': '\ue7cf',
    'zhuanyequanwei': '\ue8cf',
    'share': '\ue7d0',
    'zhanghucaozuo': '\ue8d0',
    'signboard': '\ue7d1',
    'xuanzhuandu': '\ue8d1',
    'shuffling-banner': '\ue7d2',
    'tuishuirongzi': '\ue8d2',
    'Rightbutton': '\ue7d3',
    'AddProducts': '\ue8d3',
    'sorting': '\ue7d4',
    'ziyingyewu': '\ue8d4',
    'sound-Mute': '\ue7d5',
    'addcell': '\ue8d5',
    'Similarproducts': '\ue7d6',
    'background-color': '\ue8d6',
    'sound-filling': '\ue7d7',
    'cascades': '\ue8d7',
    'suggest': '\ue7d8',
    'beijing': '\ue8d8',
    'stop': '\ue7d9',
    'bold': '\ue8d9',
    'success': '\ue7da',
    'zijin': '\ue8da',
    'supplier-features': '\ue7db',
    'eraser': '\ue8db',
    'switch': '\ue7dc',
    'centeralignment': '\ue8dc',
    'survey': '\ue7dd',
    'click': '\ue8dd',
    'template': '\ue7de',
    'aspjiesuan': '\ue8de',
    'text': '\ue7df',
    'flag': '\ue8df',
    'suspended': '\ue7e0',
    'falg-fill': '\ue8e0',
    'task-management': '\ue7e1',
    'Fee': '\ue8e1',
    'tool': '\ue7e2',
    'filling': '\ue8e2',
    'Top': '\ue7e3',
    'Foreigncurrency': '\ue8e3',
    'smile': '\ue7e4',
    'guanliyuan': '\ue8e4',
    'textile-products': '\ue7e5',
    'language': '\ue8e5',
    'tradealert': '\ue7e6',
    'leftalignment': '\ue8e6',
    'topsales': '\ue7e7',
    'extra-inquiries': '\ue8e7',
    'tradingvolume': '\ue7e8',
    'Italic': '\ue8e8',
    'training': '\ue7e9',
    'pcm': '\ue8e9',
    'upload': '\ue7ea',
    'reducecell': '\ue8ea',
    'RFQ-word': '\ue7eb',
    'rightalignment': '\ue8eb',
    'viewlarger': '\ue7ec',
    'pointerleft': '\ue8ec',
    'viewgallery': '\ue7ed',
    'subscript': '\ue8ed',
    'vehivles': '\ue7ee',
    'square': '\ue8ee',
    'trust': '\ue7ef',
    'superscript': '\ue8ef',
    'warning': '\ue7f0',
    'tag-subscript': '\ue8f0',
    'warehouse': '\ue7f1',
    'danjuzhuanhuan': '\ue8f1',
    'shoes': '\ue7f2',
    'Transfermoney': '\ue8f2',
    'video': '\ue7f3',
    'under-line': '\ue8f3',
    'viewlist': '\ue7f4',
    'xiakuangxian': '\ue8f4',
    'set': '\ue7f5',
    'shouqi': '\ue8f5',
    'store': '\ue7f6',
    'zhankai': '\ue8f6',
    'tool-hardware': '\ue7f7',
    'tongxunlu': '\ue8f7',
    'vs': '\ue7f8',
    'yiguanzhugongyingshang': '\ue8f8',
    'toy': '\ue7f9',
    'goumaipianhao': '\ue8f9',
    'sport': '\ue7fa',
    'Subscribe': '\ue8fa',
    'creditcard': '\ue7fb',
    'becomeagoldsupplier': '\ue8fb',
    'contacts': '\ue7fc',
    'new': '\ue8fc',
    'checkstand': '\ue7fd',
    'free': '\ue8fd',
    'aviation': '\ue7fe',
    'cad-fill': '\ue8fe',
    'Daytimemode': '\ue7ff',
    'robot': '\ue8ff',
    'infantmom': '\ue800',
    'inspection1': '\ue900',
    'discounts': '\ue801',
    'block': '\ue901',
    'invoice': '\ue802',
    'shouhuoicon': '\ue902',
    'insurance': '\ue803',
    'nightmode': '\ue804',
    'usercenter': '\ue805',
    'unlock': '\ue806',
    'vip': '\ue807',
    'wallet': '\ue808',
    'landtransportation': '\ue809',
    'voice': '\ue80a',
    'exchangerate': '\ue80b',
    'contacts-fill': '\ue80c',
    'add-account1': '\ue80d',
    'years-fill': '\ue80e',
    'add-cart-fill': '\ue80f',
    'add-fill': '\ue810',
    'all-fill1': '\ue811',
    'ashbin-fill': '\ue812',
    'calendar-fill': '\ue813',
    'bad-fill': '\ue814',
    'bussiness-man-fill': '\ue815',
    'atm-fill': '\ue816',
    'cart-full-fill': '\ue817',
    'cart-Empty-fill': '\ue818',
    'cameraswitching-fill': '\ue819',
    'atm-away-fill': '\ue81a',
    'certified-supplier-fill': '\ue81b',
    'calculator-fill': '\ue81c',
    'clock-fill': '\ue81d',
    'ali-clould-fill': '\ue81e',
    'color-fill': '\ue81f',
    'coupons-fill': '\ue820',
    'cecurity-protection-fill': '\ue821',
    'credit-level-fill': '\ue822',
    'auto': '\ue6eb',
    'default-template-fill': '\ue823',
    'all': '\ue6ef',
    'CurrencyConverter-fill': '\ue824',
    'bussiness-man': '\ue6f0',
    'Customermanagement-fill': '\ue825',
    'component': '\ue6f2',
    'discounts-fill': '\ue826',
    'code': '\ue6f3',
    'Daytimemode-fill': '\ue827',
    'copy': '\ue6f4',
    'exl-fill': '\ue828',
    'dollar': '\ue6f5',
    'cry-fill': '\ue829',
    'history': '\ue6f8',
    'email-fill': '\ue82a',
    'editor': '\ue6f6',
    'filter-fill': '\ue82b',
    'data': '\ue6f9',
    'folder-fill': '\ue82c',
    'gift': '\ue6fa',
    'feeds-fill': '\ue82d',
    'integral': '\ue6fb',
    'gold-supplie-fill': '\ue82e',
    'nav-list': '\ue6fd',
    'form-fill': '\ue82f',
    'pic': '\ue6ff',
    'camera-fill': '\ue830',
    'Notvisible': '\ue6fe',
    'good-fill': '\ue831',
    'play': '\ue701',
    'image-text-fill': '\ue832',
    'inspection-fill': '\ue833',
    'QRcode': '\ue704',
    'hot-fill': '\ue834',
    'rmb': '\ue705',
    'company-fill': '\ue835',
    'similar-product': '\ue707',
    'discount-fill': '\ue836',
    'Exportservices': '\ue702',
    'insurance-fill': '\ue837',
    'sendinquiry': '\ue70d',
    'inquiry-template-fill': '\ue838',
    'all-fill': '\ue718',
    'leftbutton-fill': '\ue839',
    'favorites-fill': '\ue721',
    'integral-fill1': '\ue83a',
    'integral-fill': '\ue726',
    'help1': '\ue83b',
    'namecard-fill': '\ue72a',
    'listing-content-fill': '\ue83c',
    'pic-fill': '\ue72e',
    'logistic-logo-fill': '\ue83d',
    'play-fill': '\ue72f',
    'Moneymanagement-fill': '\ue83e',
    'prompt-fill': '\ue730',
    'manage-order-fill': '\ue83f',
    'stop-fill': '\ue738',
    'multi-language-fill': '\ue840',
    'column': '\ue741',
    'logistics-icon-fill': '\ue841',
    'add-account': '\ue742',
    'Newuserzone-fill': '\ue842',
    'column1': '\ue743',
    'nightmode-fill': '\ue843',
    'add': '\ue744',
    'office-supplies-fill': '\ue844',
    'agriculture': '\ue745',
    'notice-fill': '\ue845',
    'years': '\ue746',
    'mute': '\ue846',
    'add-cart': '\ue747',
    'order-fill': '\ue847',
    'password1': '\ue848',
    'folderMinus': '\ueabe',
    'folderOpen': '\ueabf',
    'gf-folderMinus': '\ueac5',
    'gf-folderOpen': '\ueac6',
    'quxiaoquanping': '\ueb10',
    'quanping': '\ueb11',
    'yunshangchuan': '\ue6aa',
    'logo-vue': '\ue903'
}
